import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import CaseStudySection1 from '../../components/casestudy/casestudysection1';
import CaseStudySection2 from '../../components/casestudy/casestudysection2';
import BlogsSection from '../../components/home/BlogsSection';
import MapSection from '../../components/home/MapSection';
import ContactSection from '../../components/home/ContactSection';

const CaseStudyPage = () => {
  return (
    <div className="casestudy-page">
      <CaseStudySection1 
        description="By following clear and consistent development processes, we deliver solutions that users truly appreciate. At Chudasama Outsourcing, we believe that a robust IT solution can transform your business and drive substantial profits."
        buttons={
          <>
            <a href="#" className="hero-btn-primary">
              Let's More About Us <ArrowUpRight size={24} />
            </a>
            <a href="#" className="hero-btn-secondary">
              Let's Discuss Your Project <ArrowUpRight size={24} />
            </a>
          </>
        }
      />
      <CaseStudySection2 />
      <BlogsSection />
      <MapSection 
        title={<><span className="text-primary">Delivering Scan to BIM</span> Excellence Across the USA</>}
        subtitle="We proudly offer Scan to BIM services across major US locations, including: New York, California, Texas, Florida, Chicago, New Jersey, Pennsylvania, and more."
      />
      <ContactSection />
    </div>
  );
};

export default CaseStudyPage;
